import logo160 from "@/assets/mills-logo-160.webp";
import logo320 from "@/assets/mills-logo-320.webp";
import { srcSet } from "./responsive-image";

const LOGO_SRCSET = srcSet([
  [logo160, 160],
  [logo320, 320],
]);

export function BrandLogo({
  className,
  sizes = "(min-width: 640px) 176px, 132px",
  loading,
  fetchPriority = "low",
}: {
  className?: string;
  sizes?: string;
  loading?: "lazy" | "eager";
  fetchPriority?: "high" | "low" | "auto";
}) {
  return (
    <img
      src={logo160}
      srcSet={LOGO_SRCSET}
      sizes={sizes}
      alt="Mills Engraving"
      width={160}
      height={53}
      loading={loading}
      decoding="async"
      fetchPriority={fetchPriority}
      className={className}
    />
  );
}
